export default {
  className: 'my-va-top-nav',
  compact: true,
  href: '/my-va/',
  hrefInjectedHeader: 'https://va.gov/my-va/',
  title: 'My VA',
};
